import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import LightButton from '../../button/LightButton';
import HouseCalendar from './HouseCalendar';

const HouseCalendarButton = ({ houseId }) => {
  const [showCalendar, setShowCalendar] = useState(false);

  return (
    <>
      <LightButton onClick={() => setShowCalendar(true)}>Kalendarz</LightButton>

      {showCalendar && (
        <Modal
          show={showCalendar}
          onHide={() => setShowCalendar(false)}
          size="xl"
        >
          <Modal.Header className="p-4 px-5" closeButton>
            <Modal.Title>Kalendarz domku</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <HouseCalendar houseId={houseId} />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default HouseCalendarButton;
